module.exports = __webpack_public_path__ + "img/img-5.3d544b04.png";